module.exports = __webpack_public_path__ + "static/media/49_B.ba9eb02f.png";